import { useEffect } from 'react';
import * as Styled from './styled';
import * as Component from '~components';
import { useLayout } from '~hooks';
import { useOnboarding } from '~contexts/OnboardingContext';

function Created() {
  const { setLayout } = useLayout();
  const onBoarding = useOnboarding();
  const isCredit = onBoarding.acquired === 'credit';

  useEffect(() => {
    setLayout({ header: {} });
  }, [setLayout]);

  function handleClick() {
    window.location.assign(`${process.env.REACT_APP_IB_LOGIN_PAGE_URL}`);
  }

  function handleNavigate() {
    window.location.assign(
      `${process.env.REACT_APP_MF_FORMALIZACAO_URL}/credito-inicial`
    );
  }

  return (
    <>
      <Styled.Container>
        <Styled.ColumnContent>
          <Styled.Title color="success">Parabéns!</Styled.Title>
          <Styled.Title color="neutral-strong">
            Conta aberta com sucesso
          </Styled.Title>
          <Styled.SubTitle>
            {isCredit
              ? 'Após a aprovação do seu crédito, ele será disponibilizado na sua conta Fretebras abaixo.'
              : 'Você já pode aproveitar a nova Conta PJ Fretebras para sua empresa.'}
          </Styled.SubTitle>
          <Styled.Card>
            <Component.Logo />
            <Styled.TextBank>Banco</Styled.TextBank>
            <Component.Row>
              <Styled.TextCardData>655 - Banco Votorantim</Styled.TextCardData>
              <Styled.Tooltip
                text="A Fretebras não é um banco, e por tanto utilizamos
o serviço bancário do Banco Votorantim para estar
de acordo com as regras do Banco Central do Brasil."
                placement="center"
                width="383px"
              >
                <Component.Info />
              </Styled.Tooltip>
            </Component.Row>
            <Styled.RowCardData>
              <Component.Column>
                <Component.Text>Agência</Component.Text>
                <Styled.TextCardData>
                  {onBoarding.bank_account?.branch}-
                  {onBoarding.bank_account?.branch_digit}
                </Styled.TextCardData>
              </Component.Column>
              <Component.Column>
                <Component.Text>Conta</Component.Text>
                <Styled.TextCardData>
                  {onBoarding.bank_account?.account}-
                  {onBoarding.bank_account?.account_digit}
                </Styled.TextCardData>
              </Component.Column>
            </Styled.RowCardData>
          </Styled.Card>
        </Styled.ColumnContent>
        <Styled.IllustrationColumn data-testid="illustration" aria-hidden>
          {isCredit ? <Component.AllRightCredit /> : <Component.AllRight />}
        </Styled.IllustrationColumn>
      </Styled.Container>
      <Component.Footer
        marginTop="auto"
        marginTopSM="42px"
        havePaddingBottomSM
        leftButton={
          isCredit && (
            <Component.Button
              variant="tertiary"
              width="100%"
              onClick={handleClick}
            >
              Acessar conta PJ Fretebras
            </Component.Button>
          )
        }
        rightButton={
          <Component.Button
            variant="primary"
            width="100%"
            onClick={isCredit ? handleNavigate : handleClick}
          >
            {isCredit
              ? 'Prosseguir para solicitação de crédito'
              : 'Acessar conta PJ Fretebras'}
          </Component.Button>
        }
      />
    </>
  );
}

export default Created;
